module.exports = __webpack_public_path__ + "static/favicons/apple-touch-icon-57x57-5e49fd64ca89e407833f00b03489de15.png";